import Vue from "vue";

export const rankingService = {
  list,
  getById,
  getByChallenge
};

function list(params) {
  return Vue.axios.get("v2/admin/reports/ranking", { params });
}

function getById(payload) {
  const realtorId = payload.realtorId;
  const params = {
    start_date: payload.startDate,
    end_date: payload.endDate
  };

  return Vue.axios.get(`v2/admin/realtors/${realtorId}/gamification_event`, {
    params
  });
}

function getByChallenge(payload) {
  const challengeId = payload.challengeId;
  const params = {
    realtor_id: payload.realtorId,
    start_date: payload.startDate,
    end_date: payload.endDate
  };

  return Vue.axios.get(`v2/admin/challenges/${challengeId}/realtor`, {
    params
  });
}
